import React, { useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast, Toaster } from "react-hot-toast";
import { Spinner } from "react-bootstrap";
import { createNewPassword } from "services/UserManagementServices";
import TextField from "common/TextField";
import FormWrapper from "components/common/formWrapper/FormWrapper";
import { useTranslation } from "react-i18next";
import "./createPassword.scss"; // Import the CSS file for styling
import { useNavigate } from "react-router-dom";

const CreatePassword = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [buttonLoading, setButtonLoading] = useState(false);

  const validate = Yup.object({
    newPassword: Yup.string()
      .required("Das Passwort erfüllt nicht alle Anforderungen.")
      .min(8, "Das Passwort erfüllt nicht alle Anforderungen")
      .max(256, "Das Passwort erfüllt nicht alle Anforderungen")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=\[\]{};':"\\|,.<>/?]).{8,}$/,
        "Das Passwort erfüllt nicht alle Anforderungen"
      ),
    retypeNewPassword: Yup.string()
      .required("Das Passwort erfüllt nicht alle Anforderungen.")
      .min(8, "Das Passwort erfüllt nicht alle Anforderungen")
      .max(256, "Das Passwort erfüllt nicht alle Anforderungen")
      .oneOf(
        [Yup.ref("newPassword"), null],
        "Passwörter müssen übereinstimmen"
      ),
  });

  const handleSubmit = async (formik) => {
    if (formik.isValid && Object.keys(formik.touched).length > 0) {
      setButtonLoading(true);
      let result = await createNewPassword({
        inviteUserId: localStorage.getItem("userId"),
        password: formik?.values?.newPassword,
        confirmPassword: formik?.values?.retypeNewPassword,
      });
      if (result?.success) {
        navigate("/password-created", {
          state: { redirectUrl: result?.payLoad?.redirectUrl },
        });
        //window.location = "/password-created";
        setButtonLoading(false);
      } else if (result.status === 422) {
        toast.error(t(result?.data?.message));
        setButtonLoading(false);
      } else {
        toast.error(t(result?.message));
        setButtonLoading(false);
      }
      setButtonLoading(false);
    }
  };

  return (
    <FormWrapper heading="Passwort erstellen ">
      <Toaster />
      <div style={{ maxWidth: "500px" }}>
        <Formik
          initialValues={{
            newPassword: "",
            retypeNewPassword: "",
          }}
          validationSchema={validate}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form className="d-flex flex-column justify-content-center w-100">
              <p className="mt-5 text-center">
                Bitte geben Sie Ihr Passwort ein
              </p>

              <TextField
                placeholder="Passwort eingeben"
                type="password"
                name="newPassword"
              />

              <TextField
                placeholder="Passwort wiederholen"
                type="password"
                name="retypeNewPassword"
              />
              <button
                className="parentbtn"
                type="submit"
                style={{ margin: "0.4rem" }}
                onClick={() => (!buttonLoading ? handleSubmit(formik) : {})}
                disabled={!formik.isValid || !formik.dirty || buttonLoading}
              >
                {buttonLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Passwort erstellen"
                )}
              </button>
              <div className="password-rules">
                <ul>
                  <li>{t("rule-1")}</li>
                  <li>{t("rule-2")}</li>
                  <li>{t("rule-3")}</li>
                  <li>{t("rule-4")}</li>
                  <li>{t("rule-5")}</li>
                </ul>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </FormWrapper>
  );
};

export default CreatePassword;
